<template>
  <div class="slide">
    <div class="image">
      <img :src="slide.image.sizes.slide" width="700" height="400">
    </div>
    <div class="content">
      <div v-html="slide.content"></div>
      <p v-if="slide.button_link !== 'none'">
        <a class="btn btn-lg btn-primary" :href="slide.button_link_external" v-if="slide.button_link === 'ext'"
          target="_blank">{{ slide.button_link_text }}</a>
        <router-link class="btn btn-lg btn-primary" :to="internalLink" v-if="slide.button_link === 'int'">{{
          slide.button_link_text }}</router-link>
      </p>
      <div v-if="index === 0">
        <form action="https://www.paypal.com/donate" method="post" target="_top">
          <input type="hidden" name="cmd" value="_s-xclick">
          <input type="hidden" name="hosted_button_id" value="YHVZYZS95QJY2">
          <input type="submit" value="Mother’s Day Backpack Drive" class="btn btn-primary btn-lg" name="submit"
            style="cursor: pointer;" alt="PayPal - The safer, easier way to pay online!">
          <img alt="" border="0" src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif" width="1" height="1">
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'slide',
  props: ['slide', 'index'],
  computed: {
    isHashLink() {
      const postName = this.slide.button_link_internal.post_name
      return (postName === 'donate' || postName === 'events' || postName === 'contact')
    },
    internalPostName() {
      const slide = this.slide
      if (slide.button_link_internal) {
        return slide.button_link_internal.post_name === 'home' ? '' : slide.button_link_internal.post_name
      }
    },
    internalLink() {
      const slide = this.slide
      if (slide.button_link_internal) {
        return (this.isHashLink) ? '/#' + this.internalPostName : '/' + this.internalPostName
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Slide.vue?41fc0f80